import { render, staticRenderFns } from "./ScoreRatio.vue?vue&type=template&id=745f3fa1&"
import script from "./ScoreRatio.vue?vue&type=script&lang=js&"
export * from "./ScoreRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports